var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))]),_vm._t("pre-hr mb-1"),(!_vm.hide_hr)?_c('hr',{staticClass:"my-1"}):_vm._e(),_c('div',{staticClass:"flex justify-center"},[_c('p',{staticClass:"md:w-[75%] text-center mb-1"},[_vm._t("default")],2)]),_vm._t("outer-slot")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }